import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/shared/SEO";
import { faqSchema } from "@/lib/seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/context/I18nContext";

export default function FaqPage() {
  const { t } = useI18n();
  const items = t("faq.items") || [];
  // Schema.org FAQPage should always be in English for crawlers' sake — use the EN dict.
  // We still expose the localised copy in the UI.
  const enItems = (require("@/lib/i18n-dict").dictionaries.en.faq.items) || [];
  const schema = faqSchema(enItems);

  return (
    <div className="min-h-screen bg-[#FAFAF9]" data-testid="faq-page">
      <SEO
        title="FAQ — Ever Clean Home"
        description="Answers to the most common questions about booking, insurance, scheduling, payment and the Ever Clean Home satisfaction guarantee."
        jsonLd={[schema]}
      />
      <Header />
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16">
        <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter">{t("faq.title")}</h1>
        <Accordion type="single" collapsible className="mt-8">
          {items.map((q, i) => (
            <AccordionItem key={i} value={`q-${i}`} className="border-b border-[#E5E7EB]" data-testid={`faq-page-item-${i}`}>
              <AccordionTrigger className="text-left font-display font-semibold hover:text-[#0EA5A4]">{q.q}</AccordionTrigger>
              <AccordionContent className="text-[#4B5563] whitespace-pre-line">{q.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <Footer />
    </div>
  );
}
